import React, { useState } from 'react';
import AutoDocumentAnnotator from './AutoDocumentAnnotator';

const AutoAnnotationDemo = () => {
  // Sample OCR data from actual invoice
  const sampleOcrData = {
    "image": {
        "width": 3024,
        "height": 4032
    },
    "predictions": [
        {
            "width": 1695,
            "height": 91,
            "x": 1617.5,
            "y": 299.5,
            "confidence": 0.9770691990852356,
            "class_id": 5,
            "class": "MAX PIPES & FITTINGS INC",
            "detection_id": "gvision-pred-5",
            "parent_id": "image"
        },
        {
            "width": 573,
            "height": 35,
            "x": 612.5,
            "y": 728.5,
            "confidence": 0.9738444685935974,
            "class_id": 12,
            "class": "Invoice No. : 3022 / 2024-25",
            "detection_id": "gvision-pred-12",
            "parent_id": "image"
        },
        {
            "width": 572,
            "height": 119,
            "x": 1097.0,
            "y": 776.5,
            "confidence": 0.9765539169311523,
            "class_id": 16,
            "class": "Date : 31-08-2024 Date : 30.08.2024 Days Due Date :",
            "detection_id": "gvision-pred-16",
            "parent_id": "image"
        },
        {
            "width": 520,
            "height": 32,
            "x": 1089.0,
            "y": 1023.0,
            "confidence": 0.9651521444320679,
            "class_id": 30,
            "class": "Vehicle No : MH04GF5311",
            "detection_id": "gvision-pred-30",
            "parent_id": "image"
        },
        {
            "width": 622,
            "height": 33,
            "x": 627.0,
            "y": 1068.5,
            "confidence": 0.9744715690612793,
            "class_id": 31,
            "class": "E - Way Bill No : 211819007324",
            "detection_id": "gvision-pred-31",
            "parent_id": "image"
        },
        {
            "width": 913,
            "height": 36,
            "x": 775.5,
            "y": 931.0,
            "confidence": 0.9830551147460938,
            "class_id": 21,
            "class": "Transport Name : DELIVERY TAKEN BY BUYER",
            "detection_id": "gvision-pred-21",
            "parent_id": "image"
        },
        {
            "width": 206,
            "height": 29,
            "x": 2517.0,
            "y": 2416.5,
            "confidence": 0.979914665222168,
            "class_id": 86,
            "class": "4,32,699.00",
            "detection_id": "gvision-pred-86",
            "parent_id": "image"
        },
        {
            "width": 157,
            "height": 125,
            "x": 2534.5,
            "y": 2262.5,
            "confidence": 0.9885485768318176,
            "class_id": 84,
            "class": "33,002.49 33,002.49 0.28",
            "detection_id": "gvision-pred-84",
            "parent_id": "image"
        }
    ]
  };

  const [imageUrl, setImageUrl] = useState('');
  const [ocrData, setOcrData] = useState(sampleOcrData);
  const defaultImportantFields = {
    "company_name": "MAX PIPES & FITTINGS INC",
    "invoice_no": "3022 / 2024-25",
    "date": "31-08-2024",
    "vehicle_no": "MH04GF5311",
    "eway_bill_no": "211819007324",
    "total_amount": "4,32,699.00",
    "cgst": "33,002.49",
    "sgst": "33,002.49",
    "transporter_name": "DELIVERY TAKEN BY BUYER"
  };

  const [importantFields, setImportantFields] = useState(defaultImportantFields);

  // State for form inputs
  const [fieldsInput, setFieldsInput] = useState(JSON.stringify(defaultImportantFields, null, 2));
  const [ocrInput, setOcrInput] = useState(JSON.stringify(sampleOcrData, null, 2));

  const handleImageUpload = (event) => {
    const file = event.target.files[0];
    if (file) {
      const url = URL.createObjectURL(file);
      setImageUrl(url);
    }
  };

  const handleFieldsUpdate = () => {
    try {
      const parsedFields = JSON.parse(fieldsInput);
      setImportantFields(parsedFields);
    } catch (error) {
      alert('Invalid JSON format for important fields. Please check your input.');
    }
  };

  const handleOcrUpdate = () => {
    try {
      const parsedOcr = JSON.parse(ocrInput);
      setOcrData(parsedOcr);
    } catch (error) {
      alert('Invalid JSON format for OCR data. Please check your input.');
    }
  };

  const handleMatchesFound = (foundMatches) => {
    console.log('Matches found:', foundMatches);
  };

  const addNewField = () => {
    const fieldName = prompt('Enter field name (e.g., customer_name):');
    const fieldValue = prompt('Enter field value:');
    
    if (fieldName && fieldValue) {
      const updatedFields = {
        ...importantFields,
        [fieldName]: fieldValue
      };
      setImportantFields(updatedFields);
      setFieldsInput(JSON.stringify(updatedFields, null, 2));
    }
  };

  const removeField = (fieldToRemove) => {
    const updatedFields = { ...importantFields };
    delete updatedFields[fieldToRemove];
    setImportantFields(updatedFields);
    setFieldsInput(JSON.stringify(updatedFields, null, 2));
  };

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="max-w-7xl mx-auto px-4">
        <div className="mb-8">
          <h1 className="text-3xl font-bold text-gray-900 mb-4">
            Auto Document Annotation Tool
          </h1>
          <p className="text-gray-600 mb-4">
            Automatically find and highlight important field values in your document based on OCR data.
          </p>
          
          {/* Demo Notice */}
          <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-6">
            <div className="flex items-start">
              <div className="flex-shrink-0">
                <svg className="h-5 w-5 text-green-400 mt-0.5" fill="currentColor" viewBox="0 0 20 20">
                  <path fillRule="evenodd" d="M10 18a8 8 0 100-16 8 8 0 000 16zm3.707-9.293a1 1 0 00-1.414-1.414L9 10.586 7.707 9.293a1 1 0 00-1.414 1.414l2 2a1 1 0 001.414 0l4-4z" clipRule="evenodd" />
                </svg>
              </div>
              <div className="ml-3">
                <h3 className="text-sm font-medium text-green-800">
                  Demo Ready with Real Invoice Data
                </h3>
                <div className="mt-2 text-sm text-green-700">
                  <p>This demo is pre-loaded with actual invoice data from MAX PIPES & FITTINGS INC. Upload any invoice image to see the auto-annotation in action, or use your own OCR data and field values.</p>
                </div>
              </div>
            </div>
          </div>
          
          {/* Controls */}
          <div className="bg-white rounded-lg shadow p-6 mb-6">
            <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 gap-6">
              {/* Image Upload */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Upload Document Image
                </label>
                <input
                  type="file"
                  accept="image/*"
                  onChange={handleImageUpload}
                  className="block w-full text-sm text-gray-500 file:mr-4 file:py-2 file:px-4 file:rounded file:border-0 file:text-sm file:font-semibold file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                />
                {imageUrl && (
                  <p className="text-sm text-green-600 mt-2">✓ Image loaded successfully</p>
                )}
              </div>

              {/* Important Fields Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Important Fields to Find
                </label>
                <div className="space-y-2">
                  <textarea
                    value={fieldsInput}
                    onChange={(e) => setFieldsInput(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 font-mono text-xs resize-y bg-gray-50"
                    rows="8"
                    style={{ minWidth: '100%', maxWidth: '100%', overflowX: 'auto', whiteSpace: 'pre', lineHeight: '1.4' }}
                    placeholder='{"company_name": "MAX PIPES & FITTINGS INC", "invoice_no": "3022 / 2024-25"}'
                  />
                  <div className="flex gap-2">
                    <button
                      onClick={handleFieldsUpdate}
                      className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors text-sm"
                    >
                      Update Fields
                    </button>
                    <button
                      onClick={addNewField}
                      className="px-3 py-1 bg-green-500 text-white rounded hover:bg-green-600 transition-colors text-sm"
                    >
                      Add Field
                    </button>
                  </div>
                </div>
              </div>

              {/* OCR Data Input */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  OCR JSON Data
                </label>
                <div className="space-y-2">
                  <textarea
                    value={ocrInput}
                    onChange={(e) => setOcrInput(e.target.value)}
                    className="w-full px-3 py-2 border border-gray-300 rounded focus:outline-none focus:ring-2 focus:ring-blue-500 font-mono text-xs resize-y bg-gray-50"
                    rows="8"
                    style={{ minWidth: '100%', maxWidth: '100%', overflowX: 'auto', whiteSpace: 'pre', lineHeight: '1.4' }}
                    placeholder="Paste your OCR JSON data here..."
                  />
                  <button
                    onClick={handleOcrUpdate}
                    className="px-3 py-1 bg-blue-500 text-white rounded hover:bg-blue-600 transition-colors text-sm"
                  >
                    Update OCR Data
                  </button>
                </div>
              </div>
            </div>
          </div>

          {/* Current Important Fields Display */}
          {Object.keys(importantFields).length > 0 && (
            <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-6">
              <h3 className="font-semibold text-blue-800 mb-3">Current Target Fields:</h3>
              <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-3">
                {Object.entries(importantFields).map(([fieldName, fieldValue]) => (
                  <div key={fieldName} className="bg-white p-3 rounded border flex items-center justify-between">
                    <div>
                      <div className="font-medium text-gray-800">{fieldName}</div>
                      <div className="text-sm text-gray-600">{fieldValue}</div>
                    </div>
                    <button
                      onClick={() => removeField(fieldName)}
                      className="text-red-500 hover:text-red-700 ml-2"
                      title="Remove field"
                    >
                      ×
                    </button>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* Usage Instructions */}
          <div className="bg-amber-50 border border-amber-200 rounded-lg p-4 mb-6">
            <h3 className="font-semibold text-amber-800 mb-2">How it works:</h3>
            <ol className="list-decimal list-inside text-sm text-amber-700 space-y-1">
              <li>Upload a document image</li>
              <li>Specify the important field values you want to find (e.g., company name, invoice number)</li>
              <li>Provide OCR data with text regions and coordinates</li>
              <li>The system automatically matches your target values with OCR predictions</li>
              <li>Matched regions are highlighted with colored boxes and labels</li>
              <li>View matching statistics and extract the found data</li>
            </ol>
          </div>
        </div>

        {/* Auto Annotation Component */}
        {imageUrl ? (
          <AutoDocumentAnnotator
            imageUrl={imageUrl}
            ocrData={ocrData}
            importantFields={importantFields}
            onMatchesFound={handleMatchesFound}
          />
        ) : (
          <div className="bg-white rounded-lg shadow-lg p-12 text-center">
            <div className="text-gray-400 mb-4">
              <svg className="mx-auto h-16 w-16" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-lg font-medium text-gray-900 mb-2">No Image Uploaded</h3>
            <p className="text-gray-500">Please upload a document image to start auto-annotation.</p>
          </div>
        )}

        {/* Advanced Settings */}
        <div className="mt-8 bg-white rounded-lg shadow p-6">
          <details>
            <summary className="font-semibold text-gray-800 cursor-pointer mb-4">Advanced Settings & Tips</summary>
            <div className="space-y-4 text-sm text-gray-600">
              <div>
                <h4 className="font-medium text-gray-800">Matching Algorithm:</h4>
                <p>The system uses fuzzy text matching with a 60% similarity threshold. It considers exact matches, partial matches, and character-based similarity.</p>
              </div>
              <div>
                <h4 className="font-medium text-gray-800">Improving Match Accuracy:</h4>
                <ul className="list-disc list-inside space-y-1 ml-4">
                  <li>Use the exact text as it appears in the document when possible</li>
                  <li>For partial matches, include key identifying parts (e.g., "GLD/2024-25" instead of full invoice number)</li>
                  <li>Remove extra spaces and special characters if matching fails</li>
                  <li>Try variations of the text if no matches are found</li>
                </ul>
              </div>
              <div>
                <h4 className="font-medium text-gray-800">Field Naming:</h4>
                <p>Use descriptive field names like 'company_name', 'invoice_no', 'total_amount', etc. This helps with color coding and organization.</p>
              </div>
            </div>
          </details>
        </div>
      </div>
    </div>
  );
};

export default AutoAnnotationDemo;